import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { detectIncognito } from 'detectincognitojs';

let deviceId = '';

/**
 * 宽松版设备指纹生成器
 * - 基于设备特征，不依赖 localStorage
 * - 对常见的变化（如分辨率微调、浏览器小版本升级）有容忍度
 * - 同一台设备同一浏览器每次调用返回相同 ID
 */

function getDeviceId() {
  if (deviceId) return deviceId;
  const ua = navigator.userAgent;
  // 只取浏览器内核和主版本号（例如 "Chrome/120"）
  const uaShort =
    (ua.match(/(Chrome|Firefox|Safari|Edg)\/\d+/i) || [])[0] ||
    ua.match(/\(([^)]+)\)/)?.[1] ||
    'unknown';

  // 首选语言
  const language = navigator.language || 'en';

  // 时区偏移：按30分钟取整，忽略夏令时导致的±30分钟波动
  const tzOffset = Math.round(new Date().getTimezoneOffset() / 30) * 30;

  // CPU 核心数
  const cores = navigator.hardwareConcurrency || 2;

  // 操作系统平台
  const platform = navigator.platform || 'unknown';

  // 是否支持触摸（粗略）
  const touchSupport = 'ontouchstart' in window ? 1 : 0;

  // 组合特征字符串
  const fingerprint = [
    uaShort,
    language,
    tzOffset,
    cores,
    platform,
    touchSupport,
  ].join('|');

  // 2. 简单哈希（FNV-1a 变种）
  let hash = 2166136261;
  for (let i = 0; i < fingerprint.length; i++) {
    hash ^= fingerprint.charCodeAt(i);
    hash *= 16777619;
    hash >>>= 0;
  }
  // 混合字符串长度增强随机性
  hash ^= fingerprint.length;
  hash >>>= 0;

  // 3. 格式化为标准 UUID 样式（32位十六进制，带连字符）
  const hex = hash.toString(16).padStart(8, '0');
  const fullHex = (hex + hex + hex + hex).slice(0, 32);
  return deviceId = `${fullHex.slice(0, 8)}-${fullHex.slice(8, 12)}-${fullHex.slice(
    12,
    16
  )}-${fullHex.slice(16, 20)}-${fullHex.slice(20, 32)}`;
}

getDeviceId();

export default getDeviceId;